/**
 * `GET /api/admin/v2/orders` — список заказов (PAR-5189).
 *
 * Вторая версия отдаёт элемент без позиций, способа оплаты и комментария
 * клиента (`IOrderListItem`). Первая, `admin/orders`, в спеке помечена
 * `deprecated` и панелью не вызывается: список, история заказов клиента, поиск
 * заказа для привязки и заказы звонящего ходят через `getOrdersByParams`, и
 * переезд случился в одном месте.
 */
export const ORDERS_LIST_PATH = '/api/admin/v2/orders';

/**
 * `GET /api/admin/orders/download` — маршрутный лист.
 *
 * Своей второй версии у ручки нет: путь прежний, а параметры сменились вместе
 * со списком — даты днём, статусы через запятую. Путь задан явно: раньше он
 * получался заменой `/orders` в адресе списка, и после переезда списка на v2
 * такая замена дала бы несуществующий `admin/v2/orders/download`.
 *
 * ⚠️ На `par-5087` 2026-09-15 ручка отвечает `500` на любой запрос.
 */
export const ORDERS_ROUTE_SHEET_PATH = '/api/admin/orders/download';

/**
 * Потолок порции списка.
 *
 * Раньше его держал вес выдачи: заказы приходили со вложенными позициями. В v2
 * позиций нет, и потолок держит контракт — «максимум 50» в описании `limit`, —
 * и память стенда: `limit=100` роняет PHP и отдаёт HTML вместо JSON.
 */
export const ORDER_LIST_MAX_LIMIT = 50;
